






















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { QuestionForm } from "@/serve/question/question";
import { QuestionTypeForm } from "@/serve/question/questionType";

@Component({
  name: "questionAdd"
})
export default class QuestionAdd extends Vue {
  @Prop({ default: false }) public visible!: boolean;
  @Prop({ required: true }) public title!: string;
  @Prop({ required: true }) public questionForm!: QuestionForm;
  @Prop({ default: () => [] }) public typeList!: QuestionTypeForm[];
  @Prop({ default: false }) public submitLoading!: boolean;

  public get innerVisible() {
    return this.visible;
  }

  public set innerVisible(value: boolean) {
    this.$emit("update:visible", value);
  }

  public submitForm() {
    (this.$refs.questionForm as any).validate((valid: boolean) => {
      if (valid) {
        this.$emit("submit");
      }
    });
  }

  public clearValidate() {
    const formRef = this.$refs.questionForm as any;
    if (formRef) {
      formRef.clearValidate();
    }
  }

  private rules = {
    typeId: [{ required: true, message: "请选择问卷类型", trigger: "change" }],
    questionCode: [{ required: true, message: "请输入问卷编码", trigger: "blur" }],
    questionName: [{ required: true, message: "请输入问卷名称", trigger: "blur" }],
    sort: [{ required: true, message: "请输入排序", trigger: "blur" }]
  };
}
